/**
 * useApprovePayroll — mutation a bérszámfejtési futtatás jóváhagyási lépéseihez
 *
 * stage: 'bolt'     → POST /runs/:id/bolt-approve
 * stage: 'central'  → POST /runs/:id/central-review
 * stage: 'finalize' → POST /runs/:id/finalize
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { boltApprove, centralReview, finalize, type PayrollRunDto } from '../api/payroll-api';

export type ApproveStage = 'bolt' | 'central' | 'finalize';

interface ApproveInput {
  id: string;
  stage: ApproveStage;
}

export function useApprovePayroll() {
  const queryClient = useQueryClient();

  return useMutation<PayrollRunDto, Error, ApproveInput>({
    mutationFn: async ({ id, stage }: ApproveInput) => {
      let res;
      if (stage === 'bolt') {
        res = await boltApprove(id);
      } else if (stage === 'central') {
        res = await centralReview(id);
      } else {
        res = await finalize(id);
      }
      return res.data;
    },
    onSuccess: data => {
      void queryClient.invalidateQueries({ queryKey: ['payroll', 'runs'] });
      void queryClient.invalidateQueries({ queryKey: ['payroll', 'run', data.id] });
    },
  });
}
